/**
 * Portal Manta · Helpers para Excel · usa SheetJS (xlsx)
 */
import * as XLSX from 'xlsx';

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function workbookToBlob(wb) {
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  return new Blob([wbout], { type: 'application/octet-stream' });
}

export function aoaToSheet(rows) {
  return XLSX.utils.aoa_to_sheet(rows);
}

export function jsonToSheet(rows) {
  return XLSX.utils.json_to_sheet(rows);
}

export { XLSX };
